export const INVESTMENT_STATUS: {[key:string] : any } = {
    PENDING : {name: 'Pendiente', color:'orange'},
    DONE : {name: 'Finalizado', color:'green'}
  }